import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment as env} from '../../../environments/environment';
import {map} from 'rxjs/operators';
import {DateUtils} from '../../shared/date-utils';

@Injectable({
    providedIn: 'root'
})
export class RouteLoopsService {

    constructor(private http: HttpClient) {
    }

    public getRouteLoops(): Observable<RouteLoopsModel[]> {
        return this.http.post<RouteLoopsModel[]>(`${env.apiBaseUrl}/dashboard/route_loops`, {})
            .pipe(map(resp => {
                resp.forEach(item => {
                    item.effDt = DateUtils.convertToLocaleDateString(item.effDt as string);
                });
                return resp;
            }));
    }
}

export class RouteLoopsModel {
    rsid!: string;
    effDt!: string | Date;
    station!: string;
}
